import type {
  WidgetMethodSelectionResponse,
  WidgetPaymentStatusResponse,
  WidgetSessionResponse,
  WidgetStoreState,
  WidgetUiState
} from '../types/state';

const initialState: WidgetStoreState = {
  uiState: 'init',
  session: null,
  selection: null,
  status: null,
  lastError: null
};

export class WidgetStateStore {
  private state: WidgetStoreState = { ...initialState };

  getState(): WidgetStoreState {
    return this.state;
  }

  getUiState(): WidgetUiState {
    return this.state.uiState;
  }

  setUiState(uiState: WidgetUiState): void {
    this.state = {
      ...this.state,
      uiState
    };
  }

  setSession(session: WidgetSessionResponse): void {
    this.state = {
      ...this.state,
      session
    };
  }

  setSelection(selection: WidgetMethodSelectionResponse): void {
    this.state = {
      ...this.state,
      selection
    };
  }

  setStatus(status: WidgetPaymentStatusResponse): void {
    this.state = {
      ...this.state,
      status
    };
  }

  setError(message: string | null): void {
    this.state = {
      ...this.state,
      lastError: message
    };
  }

  reset(): void {
    this.state = { ...initialState };
  }
}